<template>
  <vs-row vs-justify="center">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>
        <h3 class="card-title d-flex">
          Event Notification List
        </h3>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <!-- <th>Language Name</th> -->
            <th>Notification Desc</th>
            <!-- <th>Type</th> -->
            <th>Template</th>
            <th>Status</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in notifications" :key="index">
            <td>{{ index + 1 }}</td>
            <!-- <td>{{item.languageName}}</td> -->
            <td>{{ item.desc }}</td>
            <!-- <td>{{ item.type }}</td> -->
            <td>{{ item.message }}</td>

            <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>

            <td class="td">
              <vs-button
                class="mr15"
                size="small"
                color="warning"
                @click="editingItem(item)"
                >Edit</vs-button
              >
            </td>
          </tr>
        </table>

        <vs-popup :title="'Notification'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <sub class="sub-text">Do not change placeholder</sub>
                <vs-col vs-lg="12" vs-xs="12">
                  <vs-textarea
                    type="text"
                    label="Template"
                    v-model="notificationData.message"
                  />
                </vs-col>
                <vs-col vs-lg="12" vs-xs="12" class="mt-4 p-bottom">
                  <vs-checkbox v-model="notificationData.status"
                    >Status</vs-checkbox
                  >
                  <br />
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button @click="btnAddNotification">Save</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
// import backend from "@/restbackend.js";

import { API } from "@/common/constants";

export default {
  name: "horoscope",
  components: {
    // uploader,
  },
  data: () => ({
    // title: "Post",

    notifications: [],
    defaultalert: false,
    colorx: "#0D2144",
    notificationData: {
      desc: "",
      type: "",
      message: "",
      status: true,
    },
  }),
  methods: {
    notification() {
      this.$vs.loading();
      api
        .get(API.GET_NOTIFICATION)
        .then((r) => {
          console.log(r.data);
          this.$vs.loading.close();
          this.$data.notifications = r.data;
        })
        .catch(() => {});
    },
    editingItem(item) {
      this.$data.defaultalert = true;
      this.$data.notificationData = item;
      // this.$vs.loading();
      // this.$data.horoData = item;
      // this.$vs.loading.close();
      // this.$refs.editModal.open();
    },
    btnAddNotification() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = JSON.parse(localStorage.user).token;
      }
      this.$vs.loading();
      api
        .put(API.GET_NOTIFICATION, this.$data.notificationData, {
          headers,
          params: { id: this.$data.notificationData._id },
        })
        .then((r) => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 4000,
            title: "Success",
            text: "Notification updated successfully",
            color: "success",
          });
          this.notification();
          this.$data.defaultalert = false;
        })
        .catch(() => {});
    },
  },

  mounted() {
    // this.fetchAllPost();
    this.notification();
  },
};
</script>

<style scoped>
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.sub-text {
  color: red;
}
</style>
